import CONSTANTS from "./CONSTANTS";
import actions from "./actions";
import { toast } from "react-toastify";
import { all, fork, put, select, takeLatest } from "redux-saga/effects";
import constants from "./CONSTANTS";
import mainAxios from "src/settings/axios";
import { map } from "lodash";

export const SERVICES_CCP_MR = '/services/ccp/mr/';
export const COMMON_URL = "/services/ccp/cmm/";

function checkNotificationsChanged(oldNotifications, newNotifications) {
  if (!oldNotifications) return false;

  const newIds = new Set(map(newNotifications, x => x.notificationId));
  const oldIds = new Set(map(oldNotifications, x => x.notificationId));

  return newIds.size > oldIds.size;
}


// Exporting all sagas as 1 root saga
export default function* rootSaga() {
  yield all([
  ]);
}
